import styled from 'styled-components';
import colors from '../../includes/colors';

export const ContactUsContainer = styled.div`
  ul {
    padding: 0; 
  }
  
  ul li {
    list-style: none;
  }

  .dds__contact-us-icon--mail {
    ::before {
      content: '🖂';
      color: ${ colors.blue };
      font-size: 25px;
      position: relative;
      top: 3px;
      margin-right: 10px;
    }
  }

  .dds__contact-us-icon--gear {
    ::before {
      content: '🛠';
      color: ${ colors.blue };
      font-size: 25px;
      position: relative;
      top: 3px;
      margin-right: 10px;
    }
  }

  .dds__contact-us-icon--open-mail {
    ::before {
      content: '🖆';
      color: ${ colors.blue };
      font-size: 25px;
      position: relative;
      top: 3px;
      margin-right: 10px;
    }
  }

  .dds__contact-us--ml {
    margin-left: 35px;
  }

  ul li span {
    font-family: dds-icons;
  }

  h3 {
    font-weight: 300;
  }
`

